import styled from "styled-components";
import { theme, size, media, breakpoints } from "../../../helpers/theme";
import { AdSmallText, AdSmallTextBar, Container, Description, HedSubtitle, KContactBox, PageContainer, Second, StyledLink, Zero } from '../../common-views/faq/styles';
import WarehousesMap from "../unlogged-dashboard/warehouses-map";
import { ContactArea } from "./components/ContactArea";
import { KContactBoxWithTitle } from "./components/KContactBoxWithTitle";
const title = `Kontakt`;
const subtitle = `Lorem ipsum dolor sit amet.`;
const text1 = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`
const text2 = ` Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum`;



export const Contact = () => {
    return (
        <PageContainer>
            <Zero>
                <HedSubtitle>Kontakt</HedSubtitle>
            </Zero>
            <Container>
                <First>
                    <MainTitle>Skontaktuj się z nami</MainTitle>
                </First>
                <Second>
                    <BoxContainer>
                        <KContactBoxWithTitle boxTitle={"Numer konta"} BoxDescription={
                            [

                                {
                                    key: 1,
                                    description: "12 2490 0005 0000 4000 2702 4025",
                                    isCopable: true,
                                },
                                {
                                    key: 2,
                                    description: "",
                                    isCopable: false,
                                },
                                {
                                    key: 3,
                                    description: "PKO BP Centrala",
                                    isCopable: false,
                                },
                            ]
                        } />
                        <KContactBoxWithTitle boxTitle={"Dane firmy"} BoxDescription={[
                            {
                                key: 2,
                                description: "E-magazyn Sp. z o.o.",
                                isCopable: false
                            },
                            {
                                key: 3,
                                description: "ROTA. ul. Ogrodowa 2C",
                                isCopable: false
                            },
                            {
                                key: 4,
                                description: "05-090 Raszyn, Polska",
                                isCopable: false
                            },
                        ]} />
                    </BoxContainer>
                </Second>
            </Container>

            <BoxContactArea>
                <ContactArea
                    boxTitle={"Obsługa klienta"}
                    boxPhone={" (+48 22) 720 74 04"}
                    boxPhone2={" (+48 22) 720 30 09"}
                    boxPhone3={" (+48 22) 720 30 51"}
                    boxPhone4={" (+48 22) 715 63 49"}
                    boxPhone5={"  (+48 22) 720 20 33"}
                    boxMail={"rota@rota.pl"} />
                <ContactArea
                    boxTitle={"Księgowość"}
                    boxPhone={"+48 123 456 789"}
                    boxMail={"invoices@emagazyn.pl"} />
                <ContactArea
                    boxTitle={"Sekretariat"}
                    boxPhone={"509 551 631"}
                    boxMail={"Anna.jackowska@rota.pl"} />
            </BoxContactArea>

            {/* <MapContainer>
                <Subtitle>Nasze magazyny:</Subtitle>
                <MapWraper>
                    <WarehousesMap />
                </MapWraper>
            </MapContainer> */}
        </PageContainer >
    );
};

const First = styled.div`
width: 31%;
height:100%;
@media (max-width:${size.laptop}) {
    width: 100%;  
}`;
const MainTitle = styled.h1`
font-family: ${theme.fonts.interRegular};
font-style: normal;
color:${theme.colors.black_primaryText};
margin:0px;
@media (max-width:${size.mobileS}) {
    font-size: 46px;
    line-height: 54px;
 }

${media.between('mobileS', 'laptopHelper')}{
    font-size: 48px;
    line-height: 64px;
}
 @media (min-width:${breakpoints.laptopHelper}px) {
    font-size: 64px;
    line-height: 72px;
 }
`;


const BoxContainer = styled.div`
flex-direction: row;
display: flex;
justify-content:space-around;
align-items:stretch;
@media (max-width:${size.tablet}) {
    width: 100%;  
    flex-direction: column;
}
`
const BoxContactArea = styled.div`
margin-top:81px;
display:flex;
flex-direction:row;
justify-content: space-between;
@media (max-width:${size.laptop}) {
    flex-direction:row;
    justify-content: space-evenly;
    flex-wrap:wrap;
}
`;
const Subtitle = styled.div`
padding-top:120px;
padding-bottom:24px;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 700;
font-size: 18px;
line-height: 22px;
color: ${theme.colors.black_primaryText};
`;
const MapContainer = styled.div`
display:flex;
flex-direction:column;
`;
const MapWraper = styled.div`
height:600px;
width: auto;
display: flex;
justify-content: center;
`